const objectFitImages = require("object-fit-images");

const setupObjectFitImages = function () {
  objectFitImages();
};

document.addEventListener("turbolinks:load", setupObjectFitImages);
